import React, {Component} from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import {Card, CardActions, CardText } from 'material-ui/Card';
import firebaseApp from '../../firebase/firebase';
import { loadEventsFromFirebase } from './calendar_actions';
// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

class Calendar extends Component {
  constructor() {
    super();
    this.state={
      open: false,
      start: null,
      time:'',
      end: null,
      desc: ''
    }
  }

  componentDidMount() {
    this.props.loadEventsFromFirebase();
    }

  handleNewEvent = (title, start, end, desc, user) => {
    const Ref = firebaseApp.database().ref(`events`).push()
    const Key = Ref.key;
    let updates = {}
    const event = {
      title: title,
      start: String(start),
      end: String(end),
      desc, desc,
    }
    updates[`events/${Key}`] = event
    updates[`users/${user.uid}/events/${Key}`] = true;
    firebaseApp.database().ref().update(updates)
  }

  render(){
    const newObj = {...this.props.allEvents}
    const newEventsObject = Object.values(newObj).map((event) => {
      let newStart = new Date(event.start)
      let newEnd = new Date(event.end)
      let newEvents = {...event, start: newStart, end: newEnd }
      return (
        newEvents
      )
    })
    return (
      <Card style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 30 }}>
        <CardText>
          <BigCalendar
            selectable
            events={newEventsObject}
            defaultView='week'
            scrollToTime={new Date(1970, 1, 1, 6)}
            defaultDate={new Date()}
            onSelectEvent={event => alert(`${event.title}\n${event.desc}`)}
            onSelectSlot={(slotInfo) => this.setState({
              start: slotInfo.start,
              end: slotInfo.end,
              open: true
            })}
          />
        </CardText>
        <Dialog open={this.state.open} onRequestClose={() => this.setState({open: false})} contentStyle={{ width: '100%', height: '100%'}}>
          <Card>
            <CardText>
              <TextField hintText={'Add Title'}  hintStyle={{ fontSize: 30 }} inputStyle={{ fontSize: 30}} onChange={(e) => this.setState({ title: e.target.value}) }/>

                <br />
                <br />

              <div>
                <DatePicker style={{display: "inline-block"}} value={this.state.start} onChange={(e,date) => this.setState({ start: date }) }/>
                <TimePicker style={{display: "inline-block"}} value={this.state.start} onChange={(e,date) => this.setState({ start: date }) }/>
              </div>

              <div>
                <DatePicker style={{display: "inline-block"}} value={new Date(this.state.end)} onChange={(e,date) => this.setState({ end: date }) }/>
                <TimePicker style={{display: "inline-block"}} value={new Date(this.state.end)} onChange={(e,date) => this.setState({ end: date }) }/>
              </div>

                <br />

              <div>
                <TextField hintText={'Add Description'} onChange={(e) => this.setState({ desc: e.target.value })} />
              </div>

            </CardText>
            <CardActions>
              <RaisedButton label="Save" primary={true}
                onClick={() => this.handleNewEvent( this.state.title, this.state.start, this.state.end, this.state.desc, this.props.user)}
                />
                &nbsp;
              <RaisedButton label="Cancel" secondary={true} />
            </CardActions>
          </Card>
        </Dialog>
    </Card>
    )
  }
}

const mapStateToProps = ({ auth, calendar }) => {
  const { user } = auth;
  const { allEvents } = calendar
  return { user, allEvents };
}


export default connect(mapStateToProps, {loadEventsFromFirebase})(Calendar);



// WEBPACK FOOTER //
// ./src/components/calendar/calendar.js